import React from 'react';
import CloseButton from '../../CloseButton';
import Heading from '../../Heading';
import { st, classes } from '../MessageBoxFunctionalLayout.st.css';
import { dataHooks } from '../MessageBoxFunctionalLayout.constants';
import Box from '../../Box';
import {
  MessageBoxFunctionalLayoutProps,
  MessageBoxFunctionalLayoutTheme,
} from '../MessageBoxFunctionalLayout.types';

export const HeaderLayout = ({
  title,
  onCancel,
  theme = 'blue',
  closeButton = true,
  size = 'medium',
  newColorsBranding = false,
}: Pick<
  MessageBoxFunctionalLayoutProps,
  'onCancel' | 'title' | 'closeButton'
> & {
  size: MessageBoxFunctionalLayoutProps['buttonsHeight'];
  theme: MessageBoxFunctionalLayoutTheme | 'newColorsBranding';
  newColorsBranding?: boolean;
}) => {
  return (
    <>
      <div
        className={st(classes.header, { theme, newColorsBranding })}
        data-hook={dataHooks.header}
      >
        <Heading
          size={size}
          light={!newColorsBranding}
          className={classes.heading}
          dataHook={dataHooks.headerTitle}
        >
          {title}
        </Heading>
        {closeButton && !newColorsBranding ? (
          <CloseButton
            dataHook={dataHooks.headerCloseButton}
            size={newColorsBranding ? 'large' : 'medium'}
            skin={newColorsBranding ? 'dark' : 'lightFilled'}
            onClick={onCancel}
          />
        ) : null}
      </div>
      {closeButton && newColorsBranding ? (
        <Box className={classes.controlButtons}>
          <CloseButton
            dataHook={dataHooks.headerCloseButton}
            size={newColorsBranding ? 'large' : 'medium'}
            skin={newColorsBranding ? 'dark' : 'lightFilled'}
            onClick={onCancel}
          />
        </Box>
      ) : null}
    </>
  );
};
